import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { ENV_CONFIG } from 'config/environment';

export const RealImpact = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="real-impact-container" ref={sectionRef}>
      <FadeContainer className="real-impact-title" animateNow={isInView} delay={0.2}>
        <FadeText className="eyebrow-text" text="Real Impact" progressive />
        <FadeText
          delay={0.2}
          progressive
          className="h1-dtm"
          text="Oath helps you give where it matters."
        />
      </FadeContainer>
      <div className="real-impact-text">
        <FadeText
          className="h4-text"
          text="To evaluate our effectiveness, we track the percentage of funding on Oath going to elections decided by less than 5% of votes because those are the races in which fundraising can be decisive."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Our algorithm is designed to elevate high-stakes, competitive races that are underfunded."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Approximately $1B went to Democratic candidates running for US Senate in 2024 but less than one third went to highly competitive races (decided by less than 5%)."
          inViewTrigger
          delay={0.3}
        />
        <FadeText
          className="h4-text"
          text="Giving through Oath in 2024 looked different. Over 67% of donations went to races decided by less than 5%. Our algorithm is remarkably effective at identifying high impact races– even downballot where there’s little to no polling."
          inViewTrigger
          delay={0.3}
        />
      </div>
      <FadeContainer inViewTrigger delay={0.3}>
        <video
          autoPlay
          loop
          muted
          playsInline
          id="Real impact media"
          controls
          className="real-impact-video"
        >
          <source
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/real-impact.mp4`}
            type="video/mp4"
          />
        </video>
      </FadeContainer>
    </div>
  );
};
